/* Stylesheet */

.label_container {
  .label {
    font-weight: 500;
    font-size: 1.125rem;
  }
}
